import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserAuthorization } from '../context/UserRoleAndAuthContext';
import Loader from '../components/common/Loader';

const ProtectedRoute = ({ children, allowedRoles = [], allowedAuthorizations = [] }) => {
  const { role, authorization, loading } = useUserAuthorization();
  
  if (loading) return <Loader />; 

  const roleCheck = allowedRoles.length === 0 || allowedRoles.includes(role);
  
  const authorizationCheck = allowedAuthorizations.length === 0 || allowedAuthorizations.includes(authorization);

  return (roleCheck && authorizationCheck) ? children : <Navigate to="/unauthorized" />;
};

export default ProtectedRoute;
